import { render, staticRenderFns } from "./CreditsPage.vue?vue&type=template&id=5b5a289f&scoped=true&"
import script from "./CreditsPage.vue?vue&type=script&lang=js&"
export * from "./CreditsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a289f",
  null
  
)

export default component.exports